// ======================================================================
// File Name       : ContentLinkConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const REDIRECT_MODAL = {
  [ModalIds.CONTENT_LINKING_REGISTER]: {
    OK: ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING,
  },
  [ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING]: {
    OK: ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING,
  },
  [ModalIds.CONTENT_LINKING_DETAIL]: {
    OK: ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING,
  },
};
